import { css } from 'styled-components';

import media from './media';

export default css`
  width: 100%;
  margin: 0 auto;
  max-width: 1250px;

  ${media.medium`
    max-width: 1082px;
  `}

  ${media.small`
    max-width: 928px;
  `}
`;
